// @flow
import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import i18n from 'i18n-js';

import * as selectors from '../../../reducers';
import StopCard from '../StopCard';
import type { ROUTE_STOP_TYPE } from '../../../types/routes';
import * as closeableActions from '../../../actions/closeable';
import * as changeRequestActions from '../../../actions/changeStopRequests';
import styles from '../studentCard.css';
import type { CHANGE_STOP_REQUEST_TYPE } from '../../../types/changeStopRequest';
import ChangeRequestCard from '../ChangeRequestCard';

type StopsPanelPropTypes = {
  stops: Array<ROUTE_STOP_TYPE>,
  studentId: number,
  open: Function,
  updateStateChangeStopRequestStarted: Function,
  change_requests: Array<CHANGE_STOP_REQUEST_TYPE>,
};

const StopsPanel = ({
  stops = [],
  studentId,
  open,
  updateStateChangeStopRequestStarted,
  change_requests = [],
}: StopsPanelPropTypes) => (
  <Fragment>
    <h2 className={styles.stopsTitle}>{i18n.t('labels.assignedRoutes')}</h2>
    {
      stops.map(stop => (
        <StopCard
          key={stop.id}
          name={stop.name}
          openScheduleAction={() => open(`routesCalendar${studentId}`)}
          studentId={studentId}
          type={stop.route.route_type}
        />
      ))
    }
    { change_requests.length > 0
      ? <h2 className={styles.stopsTitle}>SOLICITUDES DE CAMBIO</h2>
      : null
    }
    {
      change_requests.map(changeRequest => (
        <ChangeRequestCard
          key={changeRequest.id}
          changeRequest={changeRequest}
          approveAction={() => {
            updateStateChangeStopRequestStarted(changeRequest.id, changeRequest.instance_type, 'approved');
          }}
          rejectAction={() => {
            updateStateChangeStopRequestStarted(changeRequest.id, changeRequest.instance_type, 'rejected');
          }}
        />
      ))
    }
  </Fragment>

);

const StopsPanelComponent = connect(
  (state, { studentId }) => {
    const student = selectors.getStudent(state, studentId);
    const change_requests = selectors.getStudentChangeRequests(state, studentId);
    const stops = [];
    if (student && student.weekRouteStopSchedule) {
      Object.keys(student.weekRouteStopSchedule).forEach(
        (stopId) => {
          const elm = student.weekRouteStopSchedule[stopId];
          const stop = selectors.getRouteStop(state, stopId);
          const route = selectors.getRoute(state, elm.route);
          stops.push({ ...stop , route: route });
        },
      );
    }
    return {
      studentId,
      stops,
      change_requests,
    };
  },
  dispatch => ({
    open: id => dispatch(closeableActions.open(id)),
    updateStateChangeStopRequestStarted: (
      id: number,
      instance_type: string,
      state: string,
    ) => dispatch(
      changeRequestActions.updateStateChangeStopRequestStarted(
        id,
        instance_type,
        state,
      ),
    ),
  }),
  undefined,
)(StopsPanel);


export default StopsPanelComponent;



// WEBPACK FOOTER //
// ./src/scripts/components/StudentCard/StopsPanel/index.jsx